import { useMemo } from "react";
import "react-day-picker/dist/style.css";
import { DatePickerDropdownRoot } from "./DatePickerDropdown.styles";
import { useControlled } from "@commonlibs";
import DatePickerCalendar from "../DatePickerCalendar/DatePickerCalendar";
import useDatePickerDropdownLabel from "./hooks/useDatePickerDropdownLabel";
import { DatePickerDropdownProps } from "./DatePickerDropdown.types";
import { DATE_PICKER_CALENDAR_LOCALES } from "../DatePickerCalendar/DatePickerCalendarLocales";

export default function DatePickerDropdown({
    locale = "es",
    mode,
    placeholder,
    label: labelProp,
    defaultValue,
    value,
    onChange,
    onApply,
    onReset,
    ...rest
}: DatePickerDropdownProps) {
    //@ts-ignore - no se puede cambiar por la sugerencia de deepsource
    const [date, setDate] = useControlled(defaultValue, value, onChange);

    const finalLocale = useMemo(() => DATE_PICKER_CALENDAR_LOCALES[locale], [locale]);

    const label = useDatePickerDropdownLabel({ calendarMode: mode, date, locale: finalLocale, placeholder });

    function closeDropdown() {
        document.body.click();
    }

    function handleApply() {
        //@ts-ignore - no se puede cambiar por la sugerencia de deepsource
        onApply?.(date);
        closeDropdown();
    }

    function handleReset() {
        onReset?.();
        setDate(undefined); // skipcq: JS-W1042
        closeDropdown();
    }

    return (
        <DatePickerDropdownRoot label={labelProp || label} variant="secondary">
            {/* @ts-ignore - no se puede cambiar por la sugerencia de deepsource*/}
            <DatePickerCalendar
                {...rest}
                mode={mode}
                locale={locale}
                onApply={handleApply}
                onReset={handleReset}
                value={date}
                onChange={setDate}
            />
        </DatePickerDropdownRoot>
    );
}
